/**
 * created by wang lei
 有序列表
 *
 */
import React, {Component} from 'react';
import listNumbers from './listNumbers.png'
import SelectTool from "../components/selectTool";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class ListNumbersTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options:[
                {key:'decimal', val:'1,2,3...', checked: false},
                {key:'lower-alpha', val:'a,b,c...', checked: false},
                {key:'lower-roman', val:'i,ii,iii...', checked: false},
                {key:'upper-alpha', val:'A,B,C...', checked: false},
                {key:'upper-roman', val:'I,II,III...', checked: false},
            ],
            defaultOption: 'decimal',
            listNumbers:false,
        }
    }

    /**
     * 监听内容变化
     */
    listenContentChange(){
        let ulKey = this.props.editor.queryCommandValue("insertorderedlist"); // decimal,lower-alpha,lower-roman,upper-alpha,upper-roman,
        this.state.options.map(item=>{
            if(item.key ===  ulKey ){
                item.checked = true;
            }else{
                item.checked = false;
            }
        });
        this.setState({listNumbers: ulKey !== null});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let ulKey = this.props.editor.queryCommandValue("insertorderedlist"); // decimal,lower-alpha,lower-roman,upper-alpha,upper-roman,
        this.state.options.map(item=>{
            if(item.key ===  ulKey ){
                item.checked = true;
            }else{
                item.checked = false;
            }
        });
        this.selectTool.hide();
        this.setState({listNumbers: ulKey !== null});
    }

    render() {
        let style = {};
        if(this.state.listNumbers){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return <div className={"editor-insert-ordered-list-tool-btn"} style={style}>
            <SelectTool
            ref={ref=>this.selectTool=ref}
            editor={this.props.editor}
            options={this.state.options}
            defaultOption={'decimal'}
            configKey={'insertorderedlist'}
            imgUrl={listNumbers}
            onClickCall={(data) => {
                if (data) {
                    this.setState({listNumbers: !this.state.listNumbers})
                }
            }}
        />
            <style>{`
                .editor-insert-ordered-list-tool-btn{
                    border: 1px solid #f2f6fc;
                }
                .editor-insert-ordered-list-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-insert-ordered-list-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
        </div>
    }
}